import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { StatusMovimentacao } from "../models/status-movimentacao.model";

@Injectable()
export class StatusMovimentacaoService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Status Movimentação por id
     * @param id ID da Status Movimentação
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "status-movimentacao/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Status Movimentação
     * @param id ID da Status Movimentação
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "status-movimentacao" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Status Movimentação
     */
    getLista(params: any): Observable<ApiPaginationResponseDataNonNullable<StatusMovimentacao>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }
        return this._http.get<ApiPaginationResponseDataNonNullable<StatusMovimentacao>>(
            this.utilitesService.urlPrefix + "status-movimentacao/lista" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Delete de Status Movimentação
     * @param id ID da Status Movimentação
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "status-movimentacao/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Status Movimentação
     * @param params Json Status Movimentação
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "status-movimentacao", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Status Movimentação
     * @param params Json Status Movimentação
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "status-movimentacao/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
